module.exports = __webpack_public_path__ + "img/About-Timeline.0487e3f2.png";